import React from 'react';
import './Pricing.css';

const Pricing = ({ onOpenModal }) => {

  return (
    <section className="pricing" id="piani">
      <div className="container">
        <h2 className="section-title">PIANI DI PROTEZIONE</h2>
        <p className="section-subtitle">
          Scegli la soluzione perfetta per le tue esigenze di <span className="highlight-blue">cybersicurezza</span>
        </p>
        
        <div className="pricing-grid">
          {/* Piano Base - Sentinella */}
          <div className="pricing-card">
            <div className="pricing-header">
              <div className="plan-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C13.1046 22 14 21.1046 14 20H10C10 21.1046 10.8954 22 12 22Z" fill="currentColor"/>
                  <path d="M18.7491 9C18.7491 5.13401 15.8661 2 12.0001 2C8.13407 2 5.25107 5.13401 5.25107 9C5.25107 13.0736 4.10744 15.0609 3.61536 15.8014C3.22137 16.3796 3.02438 16.6687 3.01493 16.7853C2.99859 16.9718 3.02705 17.0033 3.14434 17.1433C3.23533 17.2533 3.51538 17.2533 4.07547 17.2533H19.9248C20.4849 17.2533 20.7649 17.2533 20.8559 17.1433C20.9732 17.0033 21.0016 16.9718 20.9853 16.7853C20.9758 16.6687 20.7788 16.3796 20.3848 15.8014C19.8928 15.0609 18.7491 13.0736 18.7491 9Z" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="plan-name">Sentinella</h3>
              <p className="plan-tagline">Protezione Essenziale</p>
            </div>

            <div className="pricing-features">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><span className="highlight-blue">Monitoraggio intelligente</span> del sistema in tempo reale</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Aggiornamenti automatici <span className="highlight-yellow">silenziosi</span> e continui</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><span className="highlight-blue">Protezione base</span> contro virus e malware</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Interfaccia <span className="highlight-yellow">semplice e intuitiva</span></span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Supporto email durante orari lavorativi</span>
              </div>
            </div>

            <div className="plan-specs">
              <div className="spec-item">
                <span className="spec-label">Dispositivi:</span>
                <span className="spec-value">1 PC</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">Impatto prestazioni:</span>
                <span className="spec-value">Minimo</span>
              </div>
            </div>

            <div className="pricing-footer">
              <button className="btn btn-outline pricing-btn" onClick={onOpenModal}>
                <span>Scegli Piano Base</span>
                <span className="btn-arrow">→</span>
              </button>
            </div>
          </div>

          {/* Piano Intermedio - Sicuro */}
          <div className="pricing-card featured">
            <div className="popular-badge">PIÙ POPOLARE</div>
            <div className="pricing-header">
              <div className="plan-icon featured-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" fill="currentColor"/>
                  <path d="M10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z" fill="white"/>
                </svg>
              </div>
              <h3 className="plan-name">Sicuro</h3>
              <p className="plan-tagline">Protezione Avanzata</p>
            </div>

            <div className="pricing-features">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><strong>Tutto il "Sentinella" più:</strong></span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Protezione <span className="highlight-yellow">anti-phishing avanzata</span> con AI</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><span className="highlight-blue">Controlli dettagliati</span> delle performance e sicurezza</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><span className="highlight-yellow">Scansione email</span> in tempo reale</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Protezione <span className="highlight-blue">download e allegati</span></span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Supporto prioritario <span className="highlight-yellow">24/7</span></span>
              </div>
            </div>

            <div className="plan-specs">
              <div className="spec-item">
                <span className="spec-label">Dispositivi:</span>
                <span className="spec-value">Fino a 5 PC</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">Protezione web:</span>
                <span className="spec-value">Completa</span>
              </div>
            </div>

            <div className="pricing-footer">
              <button className="btn btn-primary pricing-btn" onClick={onOpenModal}>
                <span>Scegli Piano Intermedio</span>
                <span className="btn-arrow">→</span>
              </button>
            </div>
          </div>

          {/* Piano Premium - Inviolato */}
          <div className="pricing-card">
            <div className="pricing-header">
              <div className="plan-icon premium-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="plan-name">Inviolato</h3>
              <p className="plan-tagline">Protezione Militare</p>
            </div>

            <div className="pricing-features">
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><strong>Tutto "Sicuro" più:</strong></span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><span className="highlight-yellow">Anti-Ransomware</span> avanzato con backup automatico</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><span className="highlight-blue">Firewall Intelligente</span> con machine learning</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span><span className="highlight-yellow">Monitoraggio rete</span> e intrusioni</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Protezione <span className="highlight-blue">endpoint avanzata</span></span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <span>Supporto tecnico <span className="highlight-yellow">dedicato</span> con SLA garantito</span>
              </div>
            </div>

            <div className="plan-specs">
              <div className="spec-item">
                <span className="spec-label">Dispositivi:</span>
                <span className="spec-value">Illimitati</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">Gestione centralizzata:</span>
                <span className="spec-value">Inclusa</span>
              </div>
            </div>

            <div className="pricing-footer">
              <button className="btn btn-outline pricing-btn" onClick={onOpenModal}>
                <span>Scegli Piano Premium</span>
                <span className="btn-arrow">→</span>
              </button>
            </div>
          </div>
        </div>

        {/* Confronto con la Concorrenza */}
        <div className="comparison-section">
          <h2 className="section-title">CONFRONTO CON LA CONCORRENZA</h2>
          
          <div className="comparison-table">
            <div className="table-header">
              <div className="header-cell">Caratteristiche</div>
              <div className="header-cell">Altri Antivirus</div>
              <div className="header-cell highlighted">La Nostra Soluzione</div>
            </div>
            
            <div className="table-row">
              <div className="cell">Sviluppo Europeo</div>
              <div className="cell">No</div>
              <div className="cell highlighted">Sì</div>
            </div>
            
            <div className="table-row">
              <div className="cell">Protezione Web Integrata</div>
              <div className="cell">Limitata</div>
              <div className="cell highlighted">Completa</div>
            </div>
            
            <div className="table-row">
              <div className="cell">Anti-Phishing Avanzato</div>
              <div className="cell">Base</div>
              <div className="cell highlighted">Intelligente</div>
            </div>
            
            <div className="table-row">
              <div className="cell">Impatto sulle Prestazioni</div>
              <div className="cell">Medio-Alto</div>
              <div className="cell highlighted">Minimo</div>
            </div>
            
            <div className="table-row">
              <div className="cell">Facilità d'Uso</div>
              <div className="cell">Complicata</div>
              <div className="cell highlighted">Intuitiva</div>
            </div>
            
            <div className="table-row">
              <div className="cell">Supporto in Italiano</div>
              <div className="cell">Limitato</div>
              <div className="cell highlighted">Nativo</div>
            </div>
            
            <div className="table-row">
              <div className="cell">Privacy dei Dati</div>
              <div className="cell">Raccolta Dati</div>
              <div className="cell highlighted">GDPR Compliant</div>
            </div>
            
            <div className="table-row">
              <div className="cell">Prezzo</div>
              <div className="cell">Elevato</div>
              <div className="cell highlighted">Competitivo</div>
            </div>
          </div>
          
          <p className="comparison-note">
            A differenza dei grandi antivirus internazionali, la <span className="highlight-blue">nostra soluzione è progettata 
            specificamente per gli utenti italiani ed europei</span>, garantendo <span className="highlight-yellow">massima privacy, 
            facilità d'uso e protezione completa</span> senza compromessi.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing; 